export default __webpack_public_path__ + "static/media/product.1fd1b12f.svg";